module.exports = __webpack_public_path__ + "img/9788996373728.b40875aa.jpg";